var map = {
	"./archive_2019_04_15_1.png": 79373,
	"./archive_2019_04_15_2.png": 52924,
	"./archive_2019_04_15_3.png": 10061,
	"./mur_marque-places.png": 73359,
	"./thomas-william-O8RVgHW_10o-unsplash.jpg": 35402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60730;